import BaseComponent from 'scripts/BaseComponent.js';

export default class ProductSubscriptionWidget extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      productJson: '.js-productJson',
      price: '.js-price',
      variantSelect: '.js-variantId',
      sellingPlan: '.js-sellingPlan',
      selectedSellingPlan: '.js-selectedSellingPlan',
      selectedName: '.js-selectedPlanName',
      groupName: '.js-groupName',
      planPrice: '.js-planPrice',
      planCompareAt: '.js-planCompareAtPrice',
    };

    this.dom = {
      $component: component,
      $productJson: document.querySelector(this.refs.productJson),
      $price: document.querySelector(this.refs.price),
      $variantSelect: document.querySelector(this.refs.variantSelect),
      $sellingPlans: this.$getAll(this.refs.sellingPlan),
      $selectedSellingPlan: document.querySelector(this.refs.selectedSellingPlan),
      $selectedname: this.$get(this.refs.selectedName),
      $groupName: this.$get(this.refs.groupName),
      $planPrice: this.$get(this.refs.planPrice),
      $planCompareAt: this.$getAll(this.refs.planCompareAt),
    };

    this.state = {
      productData: null,
      variantSelectChangeEvent: 'variantselectchange',
    };

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
  }

  init() {
    const { dom, state } = this;
    state.productData = JSON.parse(dom.$productJson.innerHTML);

    const sellingPlanGroups = state.productData.selling_plan_groups;
    const sellingPlanAllocations = state.productData.variants.map((variant) => (
      { id: variant.id, allocations: variant.selling_plan_allocations }
    ));
    state.sellingPlanData = {
      variantAllocations: sellingPlanAllocations,
      productGroups: sellingPlanGroups,
    };

    // set initial selling plan and price
    const selectedPlan = this.$get('.selected-plan');
    const { planId } = selectedPlan.dataset;
    const currentVariant = dom.$variantSelect.value;
    const currentAllocation = this.getCurrentAllocation(currentVariant);
    this.setSelectedPlan(planId, currentAllocation.price);

    this.setClickWithElement(dom.$sellingPlans, this.updateSellingPlan);
    this.setOnCustomEvent(state.variantSelectChangeEvent, this.updateSellingPlanOnVariantChange);
  }

  updateSellingPlanOnVariantChange(event) {
    const { dom } = this;
    const { id } = event.detail;
    const currentAllocation = this.getCurrentAllocation(id);
    const currentSellingPlan = dom.$selectedSellingPlan.getAttribute('value');

    dom.$planCompareAt.forEach((element) => {
      element.innerHTML = `$${Math.floor(currentAllocation.compare_at_price / 100)}`;
    });
    dom.$planPrice.innerHTML = `$${Math.floor(currentAllocation.price / 100)}`;

    if (currentSellingPlan) {
      dom.$price.innerHTML = `$${Math.floor(currentAllocation.price / 100)}`;
    }
  }

  updateSellingPlan(plan) {
    const { dom } = this;
    const { planId, planDisplayName } = plan.dataset;
    const selectedPlan = document.querySelector('.selected-plan');
    const variantId = dom.$variantSelect.value;
    const currentAllocation = this.getCurrentAllocation(variantId);
    const price = planId ? currentAllocation.price : currentAllocation.compare_at_price;

    this.setSelectedPlan(planId, price);
    dom.$selectedname.innerHTML = planDisplayName;
    selectedPlan.classList.remove('selected-plan');
    plan.classList.add('selected-plan');
  }

  getCurrentAllocation(variantId) {
    const { state } = this;
    const { allocations } = state.sellingPlanData.variantAllocations
      .filter((variant) => `${variant.id}` === `${variantId}`)[0];
    return allocations[0];
  }

  setSelectedPlan(planId, price) {
    const { dom } = this;
    dom.$selectedSellingPlan.setAttribute('value', planId);
    dom.$price.innerHTML = `$${Math.floor(price / 100)}`;
  }
}
